import { getSessionKey, clearSessionKey } from './session'

// Custom error class for invalid session
export class InvalidSessionError extends Error {
  constructor(message: string = 'Invalid session key') {
    super(message)
    this.name = 'InvalidSessionError'
  }
}

// Function to redirect to login page
const redirectToLogin = () => {
  // Don't redirect if already on login page
  if (window.location.pathname === '/login') {
    return
  }

  // Don't redirect if on a public page
  if (window.location.pathname.startsWith('/public/')) {
    return
  }

  // Clear the invalid session key
  clearSessionKey()
  // Redirect to login page
  window.location.href = '/login'
}

// Actions that don't require Session-Key header
const PUBLIC_ACTIONS = [
  'login',
  'publicGetInvoice',
  'publicPayInvoice',
  'publicGetSubscriptionTemplate',
  'publicCheckEmailExists',
  'sendEmailOTP',
  'confirmEmailOTP',
  'publicRunSubscription',
]

export const callBillingAPI = async (
  action: string,
  params: object,
): Promise<any> => {
  const data = {
    action: action,
    data: params,
  }

  // Build headers - always include Content-Type and API-Key
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'API-Key': 'asfHyf^5H30@l',
  }

  // Add Session-Key header for all actions except public actions
  if (!PUBLIC_ACTIONS.includes(action)) {
    const sessionKey = getSessionKey()
    if (sessionKey) {
      headers['Session-Key'] = sessionKey
    }
  }

  const response = await fetch('https://secure.wf-api.com/core/billing_api', {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    throw new Error(`API Error: ${response.status}`)
  }
  const resp = await response.json()
  if (resp['error']) {
    const errorMessage = resp['message'] || 'Unknown error'

    // Check for invalid session key error
    if (errorMessage === 'invalid_session_key') {
      // Redirect to login page (no-op if already on login page)
      redirectToLogin()
      throw new InvalidSessionError()
    }

    throw new Error(errorMessage)
  }
  return resp
}

export const callProjectAPI = async (
  action: string,
  params: object,
): Promise<any> => {
  const data = {
    action: action,
    data: params,
  }

  // Build headers - always include Content-Type and API-Key
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'API-Key': 'asfHyf^5H30@l',
  }

  
   const sessionKey = getSessionKey()
   if (sessionKey) {
      headers['Session-Key'] = sessionKey
   }
  

  const response = await fetch('https://secure.wf-api.com/core/billing_project_api', {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    throw new Error(`API Error: ${response.status}`)
  }
  const resp = await response.json()
  if (resp['error']) {
    const errorMessage = resp['message'] || 'Unknown error'

    // Check for invalid session key error
    if (errorMessage === 'invalid_session_key') {
      // Redirect to login page (no-op if already on login page)
      redirectToLogin()
      throw new InvalidSessionError()
    }

    throw new Error(errorMessage)
  }
  return resp
}

export const callWFAPI = async (
  login: string,
  api_key: string,
  moduleId: string,
  type: string,
  params: object = {},
): Promise<any> => {
  const data = {
    id: 1,
    domain: 'websiteforge.com',
    wfuserlogin: login,
    wfuserpassword: api_key,
    moduleid: moduleId,
    type: type,
    data: params,
  }
  const response = await fetch('https://secure.wf-api.com/core/webservice', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    throw new Error(`API Error: ${response.status}`)
  }
  const resp = await response.json()
  if (resp['ErrorText']) {
    throw new Error(resp['ErrorText'])
  }
  return resp['Data']
}
